import { render, staticRenderFns } from "./moduleTop.vue?vue&type=template&id=98d8b208&scoped=true&"
import script from "./moduleTop.vue?vue&type=script&lang=js&"
export * from "./moduleTop.vue?vue&type=script&lang=js&"
import style0 from "./moduleTop.vue?vue&type=style&index=0&id=98d8b208&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d8b208",
  null
  
)

export default component.exports